(function () {
	'use strict';

    angular.module("imApp").factory("actStatusMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1332,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
